<template>
<div id="resources">
    <v-container grid-list-xl fluid>
        <v-layout>
            <v-dialog v-model="showResourcesForm" max-width="40%" scrollable>
                <v-card>
                    <v-toolbar dark color="orange">
                        <v-toolbar-title>Please tell us what resource to add</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click="showResourcesForm=false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex lg12 md12 xs12>
                                <v-textarea label="Message *" v-model="form.message" v-validate="{required: true}" data-vv-name="message" placeholder="" :error-messages="errors.collect('message')" required data-vv-as="Message">
                                </v-textarea>
                            </v-flex>
                        </v-layout>

                    </v-card-text>
                    <div class="form-btn text-xs-right">
                        <v-btn color="green white--text" @click="submit"><i class="fab fa-telegram-plane"></i> Send </v-btn>
                    </div>
                </v-card>
            </v-dialog>
            <v-flex xs12>
                <v-layout wrap class="text-xs-center">
                    <v-flex xs12 ma-0 pa-0>
                        <v-card color="orange" class="customcard">
                            <v-card-text class="py-0 my-0">
                                <v-flex 12 class="text-xs-right">
                                    <v-btn @click="showResourcesForm=true" outline class="btn_txtoutline"><i class="fab fa-telegram-plane"></i> Submit resources </v-btn>
                                </v-flex>
                                <v-flex xs8 offset-xs2>

                                    <h2 py-0 my-0>LOADMAX Library of Resources</h2>
                                    
       
      </v-flex>
          
         
            </v-card-text>
            </v-card>
      </v-flex>

      <v-flex md4  ma-0 pa-0>
        <v-card >
          <v-card-text >
          <div class="customBox">
       <v-icon  color="orange " title="Show Equipment List">fa fa-book</v-icon>
       <h1>  Regulations</h1>
       <p>Find out the latest in the regulations that affect you. </p>
       <ul>
            <li> <a href="https://www.ecfr.gov/cgi-bin/text-idx?SID=e80d17a6bf53f3fc5ea7701c417275f3&mc=true&tpl=/ecfrbrowse/Title49/49cfrv5_02.tpl#0FR)" target="_blank">U.S. Code of Federal Regulations (CFR)
                </a>
            </li>
            <li> <a href="https://www.fmcsa.dot.gov/regulations/title49/b/5/3" target="_blank">Search FMCSA Regulations and Interpretations - 49 CFR Parts 300-399</a></li>
            <li> <a href="https://www.ecfr.gov/cgi-bin/text-idx?SID=393c05458155ed587f6e745197828335&mc=true&tpl=/ecfrbrowse/Title49/49cfrv2_02.tpl#0" target="_blank">Search HM Regulations - 49 CFR Parts 100-177</a></li>
            <li> <a href="https://www.ecfr.gov/cgi-bin/text-idx?SID=393c05458155ed587f6e745197828335&mc=true&tpl=/ecfrbrowse/Title49/49cfrv3_02.tpl#0" target="_blank">Search HM Regulations - 49 CFR Parts 178-180</a></li>
       </ul>
        </div>
          </v-card-text>
        </v-card>
      </v-flex>
    <v-flex md4  ma-0 pa-0>
        <v-card >
          <v-card-text >
           <div class="customBox">
       <v-icon  color="orange " title="Show Equipment List">local_shipping</v-icon>
       <h1>For Carriers</h1>
       <p>Here are some of the top resources for LOADMAX drivers.</p>
       <ul>
            <li> <a href="https://www.fmcsa.dot.gov/registration/commercial-drivers-license" target="_blank">Commercial Drivers License</a></li>
            <li> <a href="https://www.fmcsa.dot.gov/regulations/hours-of-service" target="_blank">Hours of Service Regulations</a></li>
            <li> <a href="https://www.fmcsa.dot.gov/regulations/title49/b/5/3/list?filter=Driver" target="_blank">Driver Regulations</a></li>
            <li> <a href="https://www.fmcsa.dot.gov/driver-safety/distracted-driving" target="_blank">Distracted Driving / Cell Phone Bans</a></li>
       </ul>
        </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex md4  ma-0 pa-0>
        <v-card >
          <v-card-text >
           <div class="customBox">
       <v-icon  color="orange " title="Show Equipment List">fa fa-cube</v-icon>
       <h1 font-weight-bold>   For Brokers</h1>
       <p>Learn more about safety records, information and registration.</p>
       <ul>
            <li> <a href="https://www.fmcsa.dot.gov" target="_blank">FMCSA Homepage</a></li>
            <li> <a href="https://www.suretybonds.org/blog/how-to-become-a-freight-broker-ultimate-guide/" target="_blank">Legal Requirements for Freight Brokers</a></li>
            <li> <a href="https://eldfacts.com/eld-mandate/" target="_blank">ELD Mandate</a></li>
            <li> <a href="https://www.fmcsa.dot.gov/sites/fmcsa.dot.gov/files/docs/small-entity-comp-guide-broker-operations-508.pdf" target="_blank">Compliance Guide for Brokers</a></li>
       </ul>
        </div>
          </v-card-text>
        </v-card>
      </v-flex>
        
  
    </v-layout>
    </v-flex>
     </v-layout>
    </v-container>
    <GoogleAds></GoogleAds>
</div>
</template>

<script>
import {
    Validator
} from 'vee-validate';
import services from "../services/HttpService";
import GoogleAds from "@/pages/widgets/GoogleAds";
export default {
    components: {
        GoogleAds,
    },
    data() {
        return {
            showResourcesForm: false,
            form: {
                message: '',
            }
        }
    },
    methods: {
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        submit() {
            const self = this,
                wApp = window.getApp;
            self.$validator.validateAll()
                .then(isValid => {
                    if (isValid) {
                        services.post("users/enquiry", {
                                msg: self.form.message
                            }, {
                                "Authorization": "Bearer " + this.$store.state.user.token
                            })
                            .then(res => {
                                if (res.status) {
                                    self.showResourcesForm = false;
                                    self._showToast(res.data.message, "green");
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, "red");
                            });
                    }

                })

        }
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/Resource.vue